import { CardHeader as MuiCardHeader, CardHeaderProps } from "@mui/material";
import { styled } from "@mui/material/styles";

const StyledCardHeader = styled(MuiCardHeader)(({ theme }) => ({
  bottom: 0,
  left: 0,
  right: 0,
  padding: "8px",
  position: "absolute",

  "& .MuiCardHeader-content": {
    containerType: "inline-size",
    minWidth: 0,
  },

  "& .MuiCardHeader-title": {
    color: "common.white",
    fontWeight: 600,
    textShadow: `1px 1px 3px ${theme.palette.secondary[6]}`,
  },

  "& .MuiCardHeader-subheader": {
    color: theme.palette.secondary[1],
    fontWeight: 500,
    textShadow: `1px 1px 3px ${theme.palette.secondary[6]}`,
  },
}));

export const CardHeader = (props: CardHeaderProps) => (
  <StyledCardHeader
    slotProps={{
      subheader: {
        display: {
          "@": "none",
          "@150": "flex",
        },
        variant: "small",
      },
      title: {
        noWrap: true,
        variant: "regular",
      },
    }}
    {...props}
  />
);
